var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.output.textClass},[_vm._v(_vm._s(_vm.output.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }